import { HttpResponse, httpService } from '../core/http'
import { PaginatedRequest, PaginatedResponseData } from '../core/interfaces'
import { Product, ProductFilter } from '../entities/product'

export const getAllProducts = async (
  query: PaginatedRequest<ProductFilter>
): Promise<PaginatedResponseData<Product>> => {
  try {
    const httpResponse: HttpResponse = await httpService.get('/products', {
      params: {
        ...query
      }
    })

    return httpResponse.data
  } catch (error) {
    return error
  }
}
